import React from "react";
import "./Info.css";

import {
  FaCar,
  FaWatchmanMonitoring,
  FaGem,
  FaUsers,
  FaTrophy,
  FaCalculator,
} from "react-icons/fa";
import { MdDevices } from "react-icons/md";
import {Link, useNavigate} from "react-router-dom";

const Information = () => {
  const navigate = useNavigate();
  const assets = [
    {
      icon: <FaCar size={32} color="#f87171" />,
      title: "Cars",
      description:
        "We accept different models of cars, production date starting from the year 2008 such as Toyota, Honda, BMW, Chevrolet, Audi, Benz, Bentley, Rolls Royce, Lamborghini, Ferrari, Aston Martin, and Bugatti.",
    },
    {
      icon: <FaWatchmanMonitoring size={32} color="#f87171" />,
      title: "Luxury Watches",
      description:
        "Rolex, Patek Philippe, Audemars Piguet, Hublot and Richard Mille watches are accepted as collateral. We determine authenticity, condition, and market value to provide competitive loan values.",
    },
    {
      icon: <FaGem size={32} color="#f87171" />,
      title: "Jewelries",
      description:
        "Diamond rings, bracelets, necklaces, and designer jewelry are accepted. We scrutinize the craftsmanship, materials, and quality of the gemstones to provide a loan value that is reflective of true value.",
    },
    {
      icon: <MdDevices size={32} color="#f87171" />,
      title: "Gadgets",
      description:
        "We offer instant loans against high-end laptops and iPads. At Respected Solutions, we carefully assess the condition, brand, and market value of your devices to ensure you receive a fair and competitive loan amount. Whether for short-term cash flow or unexpected expenses, your valuable gadgets can help secure the funds you need quickly and discreetly.",
    },
  ];

  const steps = [
    {
      number: "01",
      title: "Apply online",
      description:
        "Fill out a quick online application or visit our office with your asset. Our team will guide you through the process and discuss the best loan options available.",
    },
    {
      number: "02",
      title: "Asset evaluation",
      description:
        "Our experts assess your asset's market value, considering factors like authenticity, purity, and demand. We then offer a loan amount based on a fair and transparent valuation.",
    },
    {
      number: "03",
      title: "Get Funded",
      description:
        "Once you accept the loan offer, we provide instant cash or a bank transfer on the same day. Your asset is securely stored, and you can reclaim it once the loan is fully repaid.",
    },
  ];

  const benefits = [
    {
      icon: <FaUsers />,
      title: "Transparent and flexible terms",
      description:
        "Our loan terms and agreement are fair and written out clearly with all costs and interest charges. No surprises. No hidden charges.",
    },
    {
      icon: <FaTrophy />,
      title: "Excellent custodian of your luxury collateral",
      description:
        "We take excellent care of your luxury assets and keep them in pristine condition till you repossess them after payment.",
    },
    {
      icon: <FaCalculator />,
      title: "Fast and easy funding",
      description:
        "We are a loan business built for speed, security, and convenience. Our unique business model allows us to serve you quickly and efficiently without the burdensome paperwork processes.",
    },
  ];

  return (
    <section className="info-container" id="loans">
      <div className="about-section">
        <div className="about-section-inner">
          <div className="about-content">
            <h3 className="about-section-title">ABOUT RESPECTED SOLUTIONS</h3>
            <h2 className="about-heading">
              A flexible alternative to traditional loans
            </h2>
            <p className="about-text">
              Need instant cash without the inconvenience of conventional bank
              loans? A Pawn shop near you that allows you to get instant cash by
              using your precious assets. Whether you require a Loan against
              gold, luxury watch, jewelry, or even a against car, we provide
              competitive interest rates and easy repayment options. Our
              government approved and licensed services guarantee a secure and
              trustworthy borrowing experience.
            </p>
          </div>
          <img
            src="/assets/images/about/about-2.jpg"
            alt="Loan Image"
            className="about-image"
          />
        </div>
      </div>

      <div className="get-cash-section">
        <div className="get-cash-section-inner">
          <div className="get-cash-content">
            <h2 className="get-cash-heading">Get cash you need right away</h2>
            <p className="get-cash-text">
              We simplify money borrowing and make it easy. If you want quick
              cash, simply bring your valuable items to us, and we will offer a
              reasonable assessment. After approval, you receive your money the
              same day. For unplanned expenses, business investment, or personal
              purposes, we assist you in releasing cash from your items without
              selling them. If you are looking for pawn shops near you, we are
              your reliable option in Lagos.
            </p>
          </div>
          <img
            src="/assets/images/about/about.jpg"
            alt="Happy person using laptop"
            className="get-cash-image"
          />
        </div>
      </div>

      <div className="collateral-section">
        <h2 className="collateral-heading">Assets we accept as collateral</h2>
        <div className="collateral-container">
          {assets.map((asset, index) => (
            <div key={index} className="collateral-item">
              <div className="icon-container">{asset.icon}</div>
              <h3 className="collateral-title">{asset.title}</h3>
              <p className="collateral-text">{asset.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="how-it-works">
        <h3 className="section-subtitle">HOW IT WORKS</h3>
        <h2 className="section-title">3 Simple Steps</h2>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <h1 className="step-number">{step.number}</h1>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
        <div className="section-apply-btn">
          <Link to="/contact-us">
            <button className="apply-button" onClick={() => {
              navigate('/contact-us')
            }}>Apply Now</button>
          </Link>
        </div>
      </div>

      <div className="why-choose-us">
        <h2 className="section-title">Why People Choose Us</h2>
        <p className="section-subtitle">
          We are Licensed and Approved by the Lagos State Government
        </p>
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-icon">{benefit.icon}</div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
              <button className="benefit-button" onClick={() => {
                navigate('/contact-us')
              }}>Get Started</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Information;
